import { SVGProps, Ref, forwardRef } from 'react';

export const CubeOutlinedSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 1 2 6.5v11L12 23l10-5.5v-11zm7.199 6.014L12 10.973l-7.199-3.96L12 3.055zM11.1 20.45l-7.3-4.015V8.517l7.3 4.015zm9.1-4.015-7.3 4.015v-7.919l7.3-4.015z"
                fill="currentColor"
            />
        </g>
    </svg>
));
CubeOutlinedSize24Glyph.displayName = 'CubeOutlinedSize24Glyph';
